var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8542 0.673938C13.619 0.541771 12.3774 0.47754 11.1353 0.481696C7.01701 0.481696 4.45802 3.13311 4.45802 7.4024V10.3005H0.998598C0.660637 10.3003 0.386502 10.5772 0.386353 10.9189V15.6869C0.386128 16.0287 0.659965 16.3058 0.997925 16.306H4.45802V25.8625C4.4578 26.2042 4.73163 26.4813 5.06959 26.4815H9.94072C10.2787 26.4817 10.5527 26.2049 10.553 25.8631V16.306H14.0017C14.3093 16.3059 14.5693 16.0752 14.6092 15.7667L15.2178 10.9994C15.2615 10.6605 15.0253 10.35 14.6901 10.3058C14.6636 10.3023 14.637 10.3005 14.6104 10.3005H10.553V7.87515C10.553 6.67454 10.7921 6.17278 12.2773 6.17278L14.7741 6.17157C15.1121 6.17172 15.3861 5.89492 15.3864 5.55321V1.28814C15.3864 0.977414 15.1589 0.714744 14.8542 0.673938ZM14.1619 4.93349L12.2773 4.9347C9.6346 4.9347 9.32848 6.61288 9.32848 7.87515V10.9197C9.32833 11.2613 9.60209 11.5385 9.94005 11.5386H13.9143L13.4635 15.0679H9.94072C9.60276 15.0677 9.3287 15.3445 9.32848 15.6863V25.2434H5.68251V15.6869C5.68273 15.3452 5.4089 15.0681 5.07101 15.0679H1.61084V11.5386H5.07027C5.40823 11.5389 5.68229 11.262 5.68251 10.9203V7.4024C5.68251 3.84412 7.72126 1.71978 11.1353 1.71978C12.3706 1.71978 13.4862 1.78749 14.1619 1.84673V4.93349Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.78aca759c3872a6366c513a038c10558.svg";
export { ForwardRef as ReactComponent };